<div class="dialogContainer" [ngClass]="{ 'visible': showDialog }">
  <div class="dialog">
    <div class="cell large-12 medium-12 small-12 bold">
      Casing Plan Schematic for Permit #{{permit?.id}}
    </div>
    @if (showDialog) {
      <div class="cell large-12 medium-12 small-12">
        @if (casingPlan != null) {
          <casing-plan-2d-schematic [casingPlan]="casingPlan" [applicationData]="applicationData" [direction]="wellDirection"></casing-plan-2d-schematic>
        } @else {
          @if (casingPlan == null) {
            <span class="bold red">No casing plan available!</span>
          }
        }
      </div>
    }
    <div class="dialogButtonsContainer">
      <div class="text-align-center">
        <button class="button margin-left no-margin-bottom outline-offset-1" [disabled]="savingDrawing?.value === true" (click)="cancel()">Cancel</button>
        <button class="button margin-left no-margin-bottom outline-offset-1" [disabled]="savingDrawing?.value === true" (click)="save()">OK</button>
      </div>
    </div>
    <text-loader [run]="savingDrawing?.value == true" [tickType]="'.'" [text]="'Saving Image'" [interval]="1500"></text-loader>
  </div>
</div>

